import { useQuery } from "react-query";
import API from "../../Config/axios";
import { QUERY_KEY } from "@Constants/query-keys";

const fetchTodaysQueueInfo = async () => {
  const { data } = await API.get("/queues/getTodaysQueueInfo");
  return data;
};

const useGetTodaysQueueInfo = (options = {}) => {
  return useQuery([QUERY_KEY.GET_TODAYS_QUEUE_INFO], fetchTodaysQueueInfo, options);
};

export default useGetTodaysQueueInfo;
